// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lt-history-plan-dialog__paper {
  border-radius: 16px !important;
  overflow: hidden;
  background: linear-gradient(165deg, #0f172a 0%, #1e293b 55%, #0b1220 100%) !important;
  color: #f8fafc;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.lt-history-plan-dialog__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 16px 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.lt-history-plan-dialog__eyebrow {
  margin: 0 0 4px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--lt-brand, #0877bc);
}

.lt-history-plan-dialog__title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 750;
  letter-spacing: -0.02em;
}

.lt-history-plan-dialog__meta {
  margin: 6px 0 0;
  font-size: 0.78rem;
  line-height: 1.35;
  color: rgba(248, 250, 252, 0.65);
}

.lt-history-plan-dialog__close {
  width: 36px;
  height: 36px;
  border: 0;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  color: #f8fafc;
  cursor: pointer;
  flex-shrink: 0;
}

.lt-history-plan-dialog__body {
  padding: 12px 14px 8px;
  max-height: min(62vh, 560px);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.lt-history-plan-dialog__status,
.lt-history-plan-dialog__error {
  margin: 8px 4px;
  font-size: 0.88rem;
}

.lt-history-plan-dialog__error {
  color: #fecaca;
}

.lt-history-plan-dialog__block {
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
  padding: 10px;
}

.lt-history-plan-dialog__block-head h3 {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
}

.lt-history-plan-dialog__block-head p {
  margin: 2px 0 8px;
  font-size: 0.72rem;
  color: rgba(248, 250, 252, 0.58);
}

.lt-history-plan-dialog__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.lt-history-plan-dialog__pick {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 9px 10px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(15, 23, 42, 0.35);
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.lt-history-plan-dialog__pick:hover {
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 45%, transparent);
}

.lt-history-plan-dialog__pick.is-active {
  border-color: var(--lt-brand, #0877bc);
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 18%, transparent);
}

.lt-history-plan-dialog__pick-name {
  font-size: 0.86rem;
  font-weight: 650;
  line-height: 1.25;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lt-history-plan-dialog__tag {
  flex-shrink: 0;
  font-size: 0.68rem;
  font-weight: 700;
  padding: 3px 7px;
  border-radius: 999px;
}

.lt-history-plan-dialog__tag--done {
  color: #86efac;
  background: rgba(34, 197, 94, 0.16);
}

.lt-history-plan-dialog__tag--never {
  color: #7dd3fc;
  background: rgba(14, 165, 233, 0.16);
}

.lt-history-plan-dialog__more {
  margin-top: 8px;
  width: 100%;
  min-height: 36px;
  border-radius: 10px;
  border: 1px dashed rgba(255, 255, 255, 0.18);
  background: transparent;
  color: rgba(248, 250, 252, 0.82);
  font: inherit;
  font-size: 0.78rem;
  font-weight: 650;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
}

.lt-history-plan-dialog__footer {
  display: flex;
  gap: 8px;
  padding: 12px 14px calc(12px + env(safe-area-inset-bottom, 0px));
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.lt-history-plan-dialog__cancel,
.lt-history-plan-dialog__apply {
  min-height: 42px;
  border-radius: 12px;
  border: 0;
  font: inherit;
  font-weight: 700;
  cursor: pointer;
}

.lt-history-plan-dialog__cancel {
  flex: 0 0 auto;
  padding: 0 14px;
  background: rgba(255, 255, 255, 0.08);
  color: #e2e8f0;
}

.lt-history-plan-dialog__apply {
  flex: 1 1 auto;
  background: var(--lt-brand, #0877bc);
  color: #fff;
}

.lt-history-plan-dialog__apply:disabled,
.lt-history-plan-dialog__cancel:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.light-mode .lt-history-plan-dialog__paper,
html[data-theme="light"] .lt-history-plan-dialog__paper {
  background: linear-gradient(165deg, #f8fafc 0%, #fff 55%, #f1f5f9 100%) !important;
  color: #0f172a;
  border-color: #cbd5e1;
}

.light-mode .lt-history-plan-dialog__header,
.light-mode .lt-history-plan-dialog__footer,
html[data-theme="light"] .lt-history-plan-dialog__header,
html[data-theme="light"] .lt-history-plan-dialog__footer {
  border-color: rgba(15, 23, 42, 0.1);
}

.light-mode .lt-history-plan-dialog__meta,
.light-mode .lt-history-plan-dialog__block-head p,
html[data-theme="light"] .lt-history-plan-dialog__meta,
html[data-theme="light"] .lt-history-plan-dialog__block-head p {
  color: #64748b;
}

.light-mode .lt-history-plan-dialog__close,
.light-mode .lt-history-plan-dialog__cancel,
html[data-theme="light"] .lt-history-plan-dialog__close,
html[data-theme="light"] .lt-history-plan-dialog__cancel {
  background: #f1f5f9;
  color: #0f172a;
}

.light-mode .lt-history-plan-dialog__block,
.light-mode .lt-history-plan-dialog__pick,
html[data-theme="light"] .lt-history-plan-dialog__block,
html[data-theme="light"] .lt-history-plan-dialog__pick {
  background: #fff;
  border-color: rgba(15, 23, 42, 0.12);
  color: #0f172a;
}

.light-mode .lt-history-plan-dialog__more,
html[data-theme="light"] .lt-history-plan-dialog__more {
  border-color: rgba(15, 23, 42, 0.18);
  color: #334155;
}

.light-mode .lt-history-plan-dialog__error,
html[data-theme="light"] .lt-history-plan-dialog__error {
  color: #b91c1c;
}
`, "",{"version":3,"sources":["webpack://./src/components/planning/CoachHistorySessionPlanDialog.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,qFAAqF;EACrF,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,kCAAkC;EAClC,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2EAA2E;AAC7E;;AAEA;EACE,sCAAsC;EACtC,yEAAyE;AAC3E;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,4CAA4C;EAC5C,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gEAAgE;EAChE,+CAA+C;AACjD;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,kFAAkF;EAClF,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;EAIE,mCAAmC;AACrC;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;EAIE,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB","sourcesContent":[".lt-history-plan-dialog__paper {\n  border-radius: 16px !important;\n  overflow: hidden;\n  background: linear-gradient(165deg, #0f172a 0%, #1e293b 55%, #0b1220 100%) !important;\n  color: #f8fafc;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.lt-history-plan-dialog__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 16px 12px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.lt-history-plan-dialog__eyebrow {\n  margin: 0 0 4px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--lt-brand, #0877bc);\n}\n\n.lt-history-plan-dialog__title {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 750;\n  letter-spacing: -0.02em;\n}\n\n.lt-history-plan-dialog__meta {\n  margin: 6px 0 0;\n  font-size: 0.78rem;\n  line-height: 1.35;\n  color: rgba(248, 250, 252, 0.65);\n}\n\n.lt-history-plan-dialog__close {\n  width: 36px;\n  height: 36px;\n  border: 0;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.08);\n  color: #f8fafc;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.lt-history-plan-dialog__body {\n  padding: 12px 14px 8px;\n  max-height: min(62vh, 560px);\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.lt-history-plan-dialog__status,\n.lt-history-plan-dialog__error {\n  margin: 8px 4px;\n  font-size: 0.88rem;\n}\n\n.lt-history-plan-dialog__error {\n  color: #fecaca;\n}\n\n.lt-history-plan-dialog__block {\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.03);\n  padding: 10px;\n}\n\n.lt-history-plan-dialog__block-head h3 {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 700;\n}\n\n.lt-history-plan-dialog__block-head p {\n  margin: 2px 0 8px;\n  font-size: 0.72rem;\n  color: rgba(248, 250, 252, 0.58);\n}\n\n.lt-history-plan-dialog__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.lt-history-plan-dialog__pick {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 9px 10px;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(15, 23, 42, 0.35);\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.lt-history-plan-dialog__pick:hover {\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 45%, transparent);\n}\n\n.lt-history-plan-dialog__pick.is-active {\n  border-color: var(--lt-brand, #0877bc);\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 18%, transparent);\n}\n\n.lt-history-plan-dialog__pick-name {\n  font-size: 0.86rem;\n  font-weight: 650;\n  line-height: 1.25;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lt-history-plan-dialog__tag {\n  flex-shrink: 0;\n  font-size: 0.68rem;\n  font-weight: 700;\n  padding: 3px 7px;\n  border-radius: 999px;\n}\n\n.lt-history-plan-dialog__tag--done {\n  color: #86efac;\n  background: rgba(34, 197, 94, 0.16);\n}\n\n.lt-history-plan-dialog__tag--never {\n  color: #7dd3fc;\n  background: rgba(14, 165, 233, 0.16);\n}\n\n.lt-history-plan-dialog__more {\n  margin-top: 8px;\n  width: 100%;\n  min-height: 36px;\n  border-radius: 10px;\n  border: 1px dashed rgba(255, 255, 255, 0.18);\n  background: transparent;\n  color: rgba(248, 250, 252, 0.82);\n  font: inherit;\n  font-size: 0.78rem;\n  font-weight: 650;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  cursor: pointer;\n}\n\n.lt-history-plan-dialog__footer {\n  display: flex;\n  gap: 8px;\n  padding: 12px 14px calc(12px + env(safe-area-inset-bottom, 0px));\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.lt-history-plan-dialog__cancel,\n.lt-history-plan-dialog__apply {\n  min-height: 42px;\n  border-radius: 12px;\n  border: 0;\n  font: inherit;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.lt-history-plan-dialog__cancel {\n  flex: 0 0 auto;\n  padding: 0 14px;\n  background: rgba(255, 255, 255, 0.08);\n  color: #e2e8f0;\n}\n\n.lt-history-plan-dialog__apply {\n  flex: 1 1 auto;\n  background: var(--lt-brand, #0877bc);\n  color: #fff;\n}\n\n.lt-history-plan-dialog__apply:disabled,\n.lt-history-plan-dialog__cancel:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.light-mode .lt-history-plan-dialog__paper,\nhtml[data-theme=\"light\"] .lt-history-plan-dialog__paper {\n  background: linear-gradient(165deg, #f8fafc 0%, #fff 55%, #f1f5f9 100%) !important;\n  color: #0f172a;\n  border-color: #cbd5e1;\n}\n\n.light-mode .lt-history-plan-dialog__header,\n.light-mode .lt-history-plan-dialog__footer,\nhtml[data-theme=\"light\"] .lt-history-plan-dialog__header,\nhtml[data-theme=\"light\"] .lt-history-plan-dialog__footer {\n  border-color: rgba(15, 23, 42, 0.1);\n}\n\n.light-mode .lt-history-plan-dialog__meta,\n.light-mode .lt-history-plan-dialog__block-head p,\nhtml[data-theme=\"light\"] .lt-history-plan-dialog__meta,\nhtml[data-theme=\"light\"] .lt-history-plan-dialog__block-head p {\n  color: #64748b;\n}\n\n.light-mode .lt-history-plan-dialog__close,\n.light-mode .lt-history-plan-dialog__cancel,\nhtml[data-theme=\"light\"] .lt-history-plan-dialog__close,\nhtml[data-theme=\"light\"] .lt-history-plan-dialog__cancel {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n.light-mode .lt-history-plan-dialog__block,\n.light-mode .lt-history-plan-dialog__pick,\nhtml[data-theme=\"light\"] .lt-history-plan-dialog__block,\nhtml[data-theme=\"light\"] .lt-history-plan-dialog__pick {\n  background: #fff;\n  border-color: rgba(15, 23, 42, 0.12);\n  color: #0f172a;\n}\n\n.light-mode .lt-history-plan-dialog__more,\nhtml[data-theme=\"light\"] .lt-history-plan-dialog__more {\n  border-color: rgba(15, 23, 42, 0.18);\n  color: #334155;\n}\n\n.light-mode .lt-history-plan-dialog__error,\nhtml[data-theme=\"light\"] .lt-history-plan-dialog__error {\n  color: #b91c1c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
